import React, { useEffect } from "react";
import {
  Typography,
  Button,
  Form,
  Checkbox,
  Input,
  notification,
  Empty,
  Spin,
} from "antd";
import { FilePdfOutlined, LoadingOutlined } from "@ant-design/icons";

const { Title, Text, Link } = Typography;

const RoleRestDokumentacija = ({ state, actions }) => {
  const { documentation, uploadingType, userManual } = state;
  const [form] = Form.useForm();

  useEffect(() => {
    actions.getDocumentation();
    actions.getUserManual();
  }, []);

  const pravnaLicaFile = documentation?.find(
    (doc) => doc.documentationType === "Pravna lica"
  );
  const fizickaLicaFile = documentation?.find(
    (doc) => doc.documentationType === "Fizička lica"
  );
  const obradaPodatakaFile = documentation?.find(
    (doc) => doc.documentationType === "Informacije o obradi podataka"
  );

  const onFinish = (values) => {
    let fileNames = [];
    for (let key in values) {
      values[key] === true && fileNames.push(key);
    }

    if (fileNames.length === 0) {
      notification.warning({
        message: "Označite dokumente koje želite poslati",
      });
      return;
    }

    const documentationToSend = {
      fileNames,
      email: values.email,
    };

    actions.documentationSendEmail(documentationToSend);
  };

  const emptyContent = () => {
    return (
      <div className="flex">
        <Empty
          imageStyle={{ height: 25 }}
          className="mt-3 mb-6 ml-6"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </div>
    );
  };

  return (
    <div className="">
      <div className="flex items-center h-20 px-6">
        <FilePdfOutlined className="text-2xl" />
        <Title className="text-dark-blue text-sm font-semibold mt-2 ml-2 mr-4">
          PREUZMITE UPUTSTVO ZA UPOTREBU APLIKACIJE
        </Title>

        <Link
          href={userManual?.fileUrl}
          target="_blank"
          className=" text-white text-center bg-light-blue font-medium w-[94px] py-1 rounded-sm border-light-blue shadow-sm"
        >
          PREUZMI
        </Link>
      </div>
      <div className="h-4 bg-padding-white"></div>
      <div className="px-6 py-8">
        <Text className="text-dark-blue text-sm font-semibold">
          OZNAČITE DOKUMENTE KOJE ŽELITE POSLATI, UPIŠITE ŽELJENU EMAIL ADRESU I
          POŠALJITE DOKUMENTACIJU
        </Text>

        <Form form={form} name="basic" onFinish={onFinish}>
          <div className="mt-8">
            <Text className="text-light-blue-login font-semibold">
              PRAVNE OSOBE
            </Text>

            {pravnaLicaFile ? (
              <Form.Item
                name={pravnaLicaFile?.fileName}
                valuePropName="checked"
                className="mt-2"
                initialValue={false}
              >
                <Checkbox>{pravnaLicaFile?.fileName.split("_")[1]}</Checkbox>
              </Form.Item>
            ) : (
              emptyContent()
            )}
          </div>
          <div>
            <Text className="text-light-blue-login font-semibold">
              FIZIČKE OSOBE
            </Text>

            {fizickaLicaFile ? (
              <Form.Item
                name={fizickaLicaFile?.fileName}
                valuePropName="checked"
                className="mt-2"
                initialValue={false}
              >
                <Checkbox>{fizickaLicaFile?.fileName.split("_")[1]}</Checkbox>
              </Form.Item>
            ) : (
              emptyContent()
            )}
          </div>
          <div>
            <Text className="text-light-blue-login font-semibold">
              INFORMACIJE O OBRADI PODATAKA
            </Text>

            {obradaPodatakaFile ? (
              <Form.Item
                name={obradaPodatakaFile?.fileName}
                valuePropName="checked"
                className="mt-2"
                initialValue={false}
              >
                <Checkbox>
                  {obradaPodatakaFile?.fileName.split("_")[1]}
                </Checkbox>
              </Form.Item>
            ) : (
              emptyContent()
            )}
          </div>
          <div className="w-72">
            <Text className="text-xs font-light italic">
              Upišite email i kliknite na pošalji da bi dostavili dokumentaciju
              na željenu adresu
            </Text>

            <Form.Item
              className="mt-2 mb-6"
              name="email"
              rules={[
                {
                  required: true,
                  message: "Unesite email!",
                },
                { type: "email" },
              ]}
            >
              <Input placeholder="email" />
            </Form.Item>
          </div>
          <div className="flex">
            <Form.Item>
              <Button
                disabled={uploadingType === "Sending email"}
                htmlType="submit"
                className="text-sm text-white bg-light-blue font-medium w-[88px] rounded-sm border-light-blue shadow-sm mt-5"
              >
                POŠALJI
              </Button>
            </Form.Item>
            {uploadingType === "Sending email" && (
              <div className="text-center ml-16">
                <Spin
                  indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
                />
                <Title className="text-light-blue text-sm font-bold mt-3">
                  <>Ovo moze potrajati!</>
                </Title>
              </div>
            )}
          </div>
        </Form>
      </div>
    </div>
  );
};

export default RoleRestDokumentacija;
